<template>
  <BaseForm
    v-model="formModel"
    :schema="getSchema(props.method as AuthMethod)"
    :when-handle-submit="handleSubmit"
  >
    <template #component-policyFlag="{ attrs, handlers }">
      <BaseCheckbox
        v-bind="attrs"
        v-on="handlers"
      >
        <p
          class="auth-signup-form__policy"
          v-html="getPolicyText()"
        />
      </BaseCheckbox>
    </template>
    <template #actions="{ nextTabindex }">
      <div class="auth-signup-form__actions">
        <div class="auth-signup-form__actions-group">
          <BaseButton
            with-decor
            with-full
            data-testid="auth-prev-btn"
            @click="emit('back')"
          >
            {{ t('Назад') }}
          </BaseButton>
          <BaseButton
            type="submit"
            with-decor
            with-full
            variant="primary"
            data-testid="auth-next-btn"
            :tabindex="nextTabindex"
          >
            {{ t('Далее') }}
          </BaseButton>
        </div>
        <div class="auth-signup-form__actions-group">
          <AuthContactDevelopersBlock />
        </div>
      </div>
    </template>
  </BaseForm>
</template>

<script setup lang="ts">
import type { AuthMethod } from '~/entities/auth'

import { useI18n } from 'vue-i18n'

import { AuthContactDevelopersBlock, useAccountStore } from '~/entities/auth'
import { permissions } from '~/shared/lib'
import { BaseButton, BaseCheckbox, BaseForm } from '~/shared/ui'
import i18n from '../model/AuthSignupForm.i18n.json'
import { getSchema } from '../model/getSchema'

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'success'): void
  (e: 'back'): void
}>()

interface Props {
  method: AuthMethod
}

const { t } = useI18n(i18n)
const accountStore = useAccountStore()
const { data } = storeToRefs(accountStore)

const formModel = ref({
  inputValue: data.value[props.method],
  policyFlag: false,
})

watch(() => props.method, () => {
  formModel.value.inputValue = data.value[props.method]
})

function getPolicyText() {
  return `${t('Нажимая кнопку "Продолжить", Вы принимаете')} <a href="${permissions.LEGAL.CONSENT.ROUTE}" target="_blank" style="color: #007bff; text-decoration: none;">${t('Пользовательское соглашение')}</a> ${t('и')} <a href="${permissions.LEGAL.PRIVACY.ROUTE}" target="_blank" style="color: #007bff; text-decoration: none;">${t('Политику конфиденциальности')}</a>`
}

async function handleSubmit(form: { inputValue: string }) {
  data.value[props.method] = form.inputValue
  emit('success')
}
</script>

<style lang="scss" scoped>
.auth-signup-form__policy {
  flex: 1;
  margin: 0;
}

.auth-signup-form__actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: rem(21px);
}

.auth-signup-form__actions-group {
  width: 100%;
  display: flex;
  gap: rem(12px);
}
</style>
